<template>
  <v-container id="page-customer-detail">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn class="mx-1" color="blue" outlined @click="updateCustomerDialog = true" iconName="mdi-pencil" :disabled="disabledByRole">수정</c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="checkCustomerType" iconName="delete" :disabled="disabledByRole">삭제</c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)" iconName="mdi-format-list-bulleted-square">돌아가기</c-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <c-card title="회원 정보" class="mb-5">
          <v-row justify="space-around" align="center">

            <div style="width: calc(100% - 250px); margin-left:30px;">
              <v-row align="center">
                <v-col class="mt-0 pt-0 mx-0 px-0" cols="12">
                  <h3>인적사항</h3>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>이름</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{customerInfo.name}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span v-if="customerInfo.registerType === 'm.on'" >활성 상태</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <template v-if="customerInfo.registerType === 'm.on'">
                    <span class="black--text">{{ $func.activeStatus(customerInfo.active)}} </span>
                    <v-chip class="white--text ml-5" @click="onShowDialog()" color="namuMint" small>이력보기</v-chip>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>성별</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{$func.gender(this.customerInfo.gender, false)}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>생년월일</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{customerInfo.birth? customerInfo.birth : '-'}}</span>
                </v-col>
                <v-col cols="12" class="my-0 py-0"></v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>주소</span>
                </v-col>
                <v-col cols="12" sm="6" md="10">
                  <div class="black--text">{{customerInfo.address}}</div>
                  <div class="black--text" v-if="this.customerInfo.addressDetails">
                    {{customerInfo.addressDetails}}
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <span>연락처</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{customerInfo.mobileNo}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>이메일</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{customerInfo.email}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>가입일</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">
                    {{ $func.dateToString(customerInfo.created)}}
                  </span>
                </v-col>

                <v-col cols="12" sm="6" md="2" v-if="customerInfo.registerType === 'm.on'">
                  <span>이용 횟수</span>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="customerInfo.registerType === 'm.on'">
                  <span class="black--text">{{customerInfo.usedCount}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2" v-if="customerInfo.registerType === 'm.on'">
                  <span>무단 취소 횟수</span>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="customerInfo.registerType === 'm.on'">
                  <span class="black--text">{{customerInfo.userCanceledCount}}</span>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col class="mt-5 pt-0 mx-0 px-0" cols="12">
                  <h3>회원 유형 정보</h3>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>회원 유형</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ customerType }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span v-if="(customerInfo.customerType && customerInfo.customerType.configValue === 'ct_pregnant')">분만 예정일</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ customerInfo.expectedDeliveryDate === null ? '' : customerInfo.expectedDeliveryDate }}</span>
                </v-col>

                <template v-if="isMobilityWeek">
                  <v-col cols="12" sm="6" md="2">
                    <span>장애 유형 및 정도</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text" v-html="customerHandicapType"/>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>휠체어 유무</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{ customerInfo.mobilityWeakInfo.wheelchair }}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>의사소통 가능 여부</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{ customerInfo.mobilityWeakInfo.isCommunicable ? '가능' : '불가능'}}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>일상생활 상태</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{ displayLifeStatus }}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>기초생활수급자 여부</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{ customerInfo.mobilityWeakInfo.isBasicLivelihood ? '예' : '아니오'}}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>비상연락망</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text" v-html="familyContactList"/>
                  </v-col>
                </template>
              </v-row>
            </div>
          </v-row>
        </c-card>

        <c-card title="그룹 정보">
          <c-table
            hide-default-footer
            :headers="groupHeader"
            :items="groupInfo"
          >
            <template #created="{item}">
              {{$func.dateToString(item.created)}}
            </template>
          </c-table>
        </c-card>
      </v-col>
    </v-row>

    <customer-c-u-dialog
      :open.sync="updateCustomerDialog"
      :customerFormData="customerInfo"
      @reqUpdateCustomer="reqUpdateCustomer"
    />

    <v-dialog v-model="stateHistoryDialog" max-width="800">
      <c-card class="white" title="활성 상태 변경 이력">
        <c-table :headers="dialogTableHeader" :items="dialogItemList" class="mt-5">
          <template #active="{item}">
            {{$func.activeStatus(item.active)}}
          </template>
          <template #adminName="{item}">
            {{item.adminId ? item.adminId.name : '-'}}
          </template>
          <template #created="{item}">
            {{$func.dateTimeToString(item.created)}}
          </template>
        </c-table>
      </c-card>
    </v-dialog>


    <v-dialog v-model="moffListDialog" persistent max-width="500">
      <c-card class="white">
        <v-row justify="center" class="my-10">
          <span>함께 가입한 오프라인 회원도 삭제 처리 하시겠습니까?</span>
        </v-row>
        <v-checkbox
          v-for="moff in moffCustomerList"
          v-model="selectedMoffCustomer"
          :label="`${moff.name} : ${moff.birth}`"
          :value="moff"
          dense
        ></v-checkbox>
        <v-row justify="center" class="mt-4">
          <c-btn color="blue" class="mr-2" outlined @click="this.onDeleteCustomers">삭제</c-btn>
          <c-btn outlined @click="moffListDialog = false">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>




  </v-container>
</template>
<script>
  import CustomerCUDialog from "./CustomerCUDialog";

  export default {
    components: {CustomerCUDialog},
    data: () => ({
      customerInfo: {
        id: '',
        name: '',
        gender: '',
        active: 'Enable',
        address: '',
        addressDetails: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        mobileNo: '',
        email: '',
        canceledCount: 0,
        customerType: {},
        joinerId: {},
        usedCount: 0,
        userCanceledCount: 0,
        registerType: '',
      },

      updateCustomerDialog: false,
      isOff: true,

      groupHeader: [
        {
          text: '그룹명',
          value: 'groupName',
          align: 'center',
          sortable: true,
        },
        {
          text: '신청 회원',
          value: 'joiner',
          align: 'center',
          sortable: true,
        },
        {
          text: '그룹 가입일',
          value: 'created',
          align: 'center',
          sortable: true,
        },
        {
          text: '그룹 유형',
          value: 'type',
          align: 'center',
          sortable: true,
        },
        {
          text: '소속 회원 수',
          value: 'memberCnt',
          align: 'center',
          sortable: true,
        },
      ],
      groupInfo: [],

      stateHistoryDialog: false,
      dialogTableHeader : [
        {
          text: '상태',
          value: 'active',
          align: 'center',
          sortable: true,
        },
        {
          text: '담당자',
          value: 'adminName',
          align: 'center',
          sortable: true,
        },
        {
          text: '변경일',
          value: 'created',
          align: 'center',
          sortable: true,
        },
      ],
      dialogItemList: [],
      moffCustomerList: [],
      moffListDialog: false,
      selectedMoffCustomer: [],
    }),
    mounted() {
      const {customerId} = this.$route.params;
      this.reqGetCustomer(customerId);
      this.reqGetJoinedGroupDetailList(customerId);
    },
    computed: {
      isMobilityWeek() { // 장애인의 경우
        return this.customerInfo.mobilityWeakInfo;
      },
      customerType() {
        if(!this.customerInfo || this.customerInfo.customerType === null) {
          return '일반';
        }

        const customerType = this.customerInfo.customerType.configValue;
        const customerTypeName = this.customerInfo.customerType.configName;
        if(customerType !== 'ct_normal' && customerType !== 'ct_guardian') {
          return '교통약자 ('+ customerTypeName +')';
        }
        return customerTypeName;
      },
      familyContactList() {
        const familyContactRelationList =
            [
              {text: '가족', value:'가족'},
              {text: '친구, 지인', value:'친구,지인'},
              {text: '복지사', value:'복지사'},
              {text: '기타', value:'기타'}
            ];
        let familyContactList = this.customerInfo.familyContactList;
        try {
          if(familyContactList) {
            familyContactList = JSON.parse(familyContactList);

            return familyContactList.map(contact => {
              let relation = familyContactRelationList.find(item => item.value === contact.relation);
              // familyContactRelationList 이외에 이전에 입력한 관계정보를 detail화면에서 표시는 해줌.
              relation = relation ? relation.text : contact.relation;
              return contact.phone + ' &nbsp ' + relation;
            }).join('<br/>');
          }
        } catch(e) {
          console.error('fail familyContactList parsing : ', e)
        }
        return '';
      },
      customerHandicapType() {
        const handicapTypeList = [
          {text: '간', value:'간'},
          {text: '뇌전증', value:'뇌전증'},
          {text: '뇌병변', value:'뇌병변'},
          {text: '시각', value:'시각'},
          {text: '신장', value:'신장'},
          {text: '심장', value:'심장'},
          {text: '안면', value:'안면'},
          {text: '언어', value:'언어'},
          {text: '자폐성', value:'자폐성'},
          {text: '장루, 요루', value:'장루,요루'},
          {text: '정신', value:'정신'},
          {text: '지적', value:'지적'},
          {text: '지체', value:'지체'},
          {text: '청각', value:'청각'},
          {text: '호흡기', value:'호흡기'},
          {text: '일시적 장애', value:'일시적장애'},
          {text: '직접입력', value:'직접입력'}
        ];
        const handicapDegreeList = [{text: '심함', value: '심함'}, {text: '심하지 않음', value: '심하지않음'}, {text: '기타', value: '기타'}];
        let handicapInfo = this.customerInfo.mobilityWeakInfo.handicapInfo;
        try {
          if(handicapInfo) {
            handicapInfo = JSON.parse(handicapInfo);

            return handicapInfo.map(handicap => {
              let type = handicapTypeList.find(handicapType => handicapType.value === handicap.type);
              type = !type ? handicap.type : type.text
              const degree = handicapDegreeList.find(handicapDegree => handicapDegree.value === handicap.degree);
              return type && degree ? type + ' (' + degree.text + ')' : '';
            }).join('<br/>');
          }
        } catch(e) {
          console.error('fail handicapInfo parsing : ', e)
        }
        return '';
      },
      disabledByRole() {
        return this.$store.state.userInfo.role === 'RM';
      },
      displayLifeStatus() {
        const status = this.customerInfo.mobilityWeakInfo.lifeStatus;
        switch (status) {
          case "완전도움" : return "완전 도움"
          case "부분도움" : return "부분 도움"
          case "독립" : return "독립"
        }
      }
    },
    methods: {
      async reqGetCustomer(customerId) {
        try {
          const res = await this.$api.getCustomer(customerId);
          this.customerInfo = res.data;
          this.isOff = (res.data.registerType === null || res.data.registerType === 'm.off') ? true : false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetCustomer'});
        }
      },
      async reqDeleteCustomer() {
        try {
          let customers = [];
          if (this.selectedMoffCustomer) {
            customers  = this.selectedMoffCustomer;
          }
          customers.push(this.customerInfo);
          const res = await this.$api.deleteCustomers(customers.map(customer => customer.id));
          if (res.data.length < 1) {
            this.$store.commit('alert', {open: true, msg: '예약건이 존재하는 회원은 삭제가 불가능합니다.'});
          } else {
            this.$store.commit('alert', {open: true, timeout: 3000, msg: "삭제 완료하였습니다. 3초 후 이전페이지로 이동합니다."});
            setTimeout(() => {
              this.$router.push('/customers');
            }, 3000);
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqDeleteCustomer'});
        }
      },
      async reqUpdateCustomer(data) {
        try {
          const res = await this.$api.updateCustomer(data);
          this.updateCustomerDialog = false;
          this.reqGetCustomer(this.customerInfo.id);

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqUpdateCustomer'});
        }
      },
      checkCustomerType() {
        // m.on 회원이면 m.off list get
        if (this.customerInfo.registerType === 'm.on') this.reqMoffCustomerList(this.customerInfo.id);
        else this.openDeleteDialog();
      },
      onSetFamily(data1, data2) {
        return data1 && data2 ? data1 + ' ' + data2 : '';
      },
      async reqGetJoinedGroupDetailList(customerId) {
        try {
          const res = await this.$api.getJoinedGroupDetailList(customerId);

          this.groupInfo = res.data.map(item => {
            item.groupName = item.groupInfo.name;
            item.type = item.groupInfo.type.configName;
            item.memberCnt = item.groupInfo.memberCnt;
            return item;
          });

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetJoinedGroupDetailList'});
        }
      },
      onShowDialog() {
        this.stateHistoryDialog = true;
        this.reqCustomerStateList();
      },
      async reqCustomerStateList() {
        try {
          const res = await this.$api.getCustomerStateList(this.$route.params.customerId);
          this.dialogItemList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqCustomerStateList'})
        }

      },
      async reqMoffCustomerList(customerId) {
        try {
          const res = await this.$api.getMoffCustomerList(customerId);

          this.moffCustomerList = res.data;
          this.selectedMoffCustomer = [];
          if (this.moffCustomerList.length > 0) this.moffListDialog = true;
          else this.openDeleteDialog();
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqMoffCustomerList'})
        }
      },
      openDeleteDialog() {
        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "회원을 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteCustomer();
            },
          });
      },
      onDeleteCustomers() {
        let customers = this.selectedMoffCustomer;
        this.reqDeleteCustomer(customers);
      }
    }
  }

</script>
<style lang="scss" scoped>
  .info-label {
    width: 100px;
  }
  .line-content::after {
    white-space: pre;
  }
</style>
